import { __assign, __rest } from "tslib";
import React from 'react';
import Select from './Select';
import { CheckboxOption } from './components/input-options';
var CheckboxSelect = function (_a) {
    var components = _a.components, props = __rest(_a, ["components"]);
    var temp = __assign(__assign({}, components), { Option: CheckboxOption });
    return (React.createElement(Select, __assign({ closeMenuOnSelect: false, hideSelectedOptions: false, isMulti: true, components: temp }, props)));
};
export default CheckboxSelect;
//# sourceMappingURL=CheckboxSelect.js.map